import React, { CSSProperties, useState } from 'react'

interface ImageButtonProps {
  src: string;
  srcPressed: string;
  onClick: () => void;
  pressed?: boolean;
  enable?: boolean;
  style?: CSSProperties;
}

export const ImageButton: React.FC<ImageButtonProps> = (props) => {
  const { enable = true } = props
  const [pressed, setPressed] = useState(false)
  const onMouseDownHandler = (): void => {
    setPressed(true)
  }
  const onMouseUpHandler = (): void => {
    setPressed(false)
  }

  return (
    <button
      onClick={() => {if (enable) {props.onClick()}}}
      onMouseDown={onMouseDownHandler}
      onMouseUp={onMouseUpHandler}
      onTouchStart={onMouseDownHandler}
      onTouchEnd={onMouseUpHandler}
      style={{ position: 'relative', ...props.style }}
    >
      <img
        src={props.src}
        alt=""
        style={{ 
          position: 'absolute', 
          top: 0,
          bottom: 0,
          left: 0,
          right: 0, 
          display: 'block',
        }}
      ></img>
      <img
        src={props.srcPressed}
        alt=""
        style={{ 
          position: 'absolute', 
          top: 0,
          bottom: 0,
          left: 0,
          right: 0, 
          visibility: pressed || props.pressed ? 'visible' : 'hidden',
        }}
      ></img>
    </button>
  )
}
